<template>
  <div class="c-library-filter">
    <nav class="c-library-filter__nav">
      <ul class="c-library-filter__list">
        <li class="c-library-filter__item">
          <a
            v-if="connection"
            href="#"
            class="c-library-filter__filter"
            :class="{'selected': filter === 'all'}"
            @click.prevent="toggleSelected('all')"
          >
            {{ $t('ALL') }}
          </a>
        </li>
        <li class="c-library-filter__item">
          <a
            href="#"
            class="c-library-filter__filter"
            :class="{'selected': filter === 'downloaded' || !connection}"
            @click.prevent="toggleSelected('downloaded')"
          >
            {{ $t('DOWNLOADED') }}
          </a>
        </li>
      </ul>
    </nav>
  </div>
</template>

<script>
export default {
  name: 'LibraryFilter',

  props: {
    filter: String,
    connection: Boolean
  },

  methods: {
    toggleSelected(val) {
      this.$emit('change-filter', val)
    }
  }
}
</script>

<style lang="scss">
@import '@/assets/scss/_vars.scss';
@import '@/assets/scss/_mixin.scss';

.c-library-filter__list {
  display: flex;
}

.c-library-filter__item {
  margin: 0 0.5rem;
}

.c-library-filter__filter {
  color: $dark-blue;

  &.selected {
    font-weight: 700;
    text-decoration: underline;
  }

  @include a11yOutline();
}
</style>
